import React, { useState, useEffect } from "react";
import Draggable from "react-draggable";
import { CloseOutlined, MailOutlined } from "@ant-design/icons";
import { Modal, Button } from "antd";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { sendTromMail } from "../../orderDetails/OrderDetailsSlice";
import { useUserBranches } from "../../../hooks/accessControl";
import {
  getReportedItems,
  setReportedStartHeader,
  setReportedStartTopContent,
  setReportedStartBottomContent,
} from "../../../components/print/printSections/trom";
import { createTromFile } from "../../../components/util/helpers";

import ReportedTromScheduling from "./ReportedTromScheduling";
var unflatten = require("flat").unflatten;

const ReportedTromModal = (props) => {
  const { record, items, onHide, visible } = props;
  const [disabled, setDisabled] = useState(true);
  const [branch, setBranch] = useState({});

  const organization = useSelector((state) => state.organization.details);
  const userBranches = useUserBranches();
  const dispatch = useDispatch();
  const intl = useIntl();
  const onCancel = () => {
    onHide();
  };
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );

  const loading = useSelector(
    (state) => state.pendingActions["orderDetails/sendTromMail"]
  );

  useEffect(() => {
    const selected =
      record &&
      userBranches.filter((i) => i.id === record["patient.branch_id"])[0];
    if (selected) {
      setBranch(selected);
    }
  }, [record, userBranches]);

  let sorted = record
    ? record.recurrent_work_events.map((obj) => ({
        ...obj,
      }))
    : [];
  sorted.sort((a, b) => a.weekday - b.weekday);

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  const makeFile = async () => {
    const reportedItems = getReportedItems(record, items);
    const total =
      Math.round(reportedItems.reduce((n, { sum }) => n + sum, 0) * 100) / 100;
    const text = "סה״כ שעות:";
    const totalText = `${text} ${total}`;
    const headerRecord = {
      organization,
      branch,
      patient: {
        ...unflatten(record).patient,
      },
      effective_from: record.effective_from,
      required_weekly_minutes: record.required_weekly_minutes,
      hasSceduling: items && items.length > 0,
      totalText,
    };
    const footerRecord = {
      organization,
    };
    let columnStyles = {
      0: { cellWidth: 90 },
      1: { cellWidth: 15 },
      2: { cellWidth: 32 },
      3: { cellWidth: 32 },
      4: { cellWidth: 13 },
    };
    const pdf = await createTromFile(
      intl.formatMessage({
        id: "app.prospectuses.printForecastsFileName",
      }),
      reportedItems,
      setReportedStartHeader,
      headerRecord,
      setReportedStartTopContent,
      setReportedStartBottomContent,
      footerRecord,
      "paging",
      94,
      intl,
      "trom",
      {
        styles: { fontSize: 11 },
        columnStyles: columnStyles,
        margin: { top: 43 },
      },
      "p",
      "print"
    );
    var base64result = pdf
      .output("datauristring")
      .substr(pdf.output("datauristring").indexOf(",") + 1);
    const params = {
      orderId: record.id,
      patientId: record["patient_id"],
      branchId: activePatient.branch,
      attachment: { base64_attachment: base64result },
      destination: record.report_as_trom
        ? record["client.email"]
        : record["trom_target_client.email"],
    };
    dispatch(sendTromMail(params));

    onHide();
  };

  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      title={null}
      width={"fit-content"}
      style={{ top: "20px", height: window.innerHeight * 0.9 }}
      styles={{
        body: {
          padding: 0,
        },
      }}
      open={visible}
      destroyOnClose={true}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
    >
      <div
        style={{ display: "flex", flexDirection: "column", maxWidth: "1000px" }}
      >
        <div
          style={{
            width: "100%",
            cursor: "move",
            height: "50px",
            position: "absolute",
            left: "0",
            top: "0",
          }}
          className="header"
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
          <Button
            style={{ position: "absolute", right: 10, top: 10 }}
            type="primary"
            loading={loading}
            icon={<MailOutlined />}
            onClick={makeFile}
          >
            {intl.formatMessage({
              id: "app.orders.send_email_to_btl",
            })}
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            margin: "60px 80px 40px 80px",
            height: window.innerHeight * 0.9 - 120,
            overflow: "auto",
          }}
        >
          <div id="reported_trom_scheduling" className="pdf" dir="rtl">
            <ReportedTromScheduling items={items} record={record} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReportedTromModal;
